import type { Deal } from 'bundles/apex/deals/types';
import type { Project } from 'bundles/apex/deals/connect_to_listing/types';

export function requiresPropertyOverride(deal: Deal, project: Project): boolean {
  if (!project?.edgeResearchProperty || !deal.researchPropertyId) {
    return false;
  }

  const projectDeals = project.listings.reduce((acc, listing) => {
    return acc + listing.dealCount;
  }, 0);
  return hasDifferentProperties(deal, project) && projectDeals === 0;
}

export function hasDifferentProperties(deal: Deal, project: Project): boolean {
  return deal.researchProperty?.id !== project.edgeResearchProperty?.id;
}